import VMasker from 'vanilla-masker';

const getOnlyNumber = (text: string): string => text.replace(/\D/g, '');
const getOnlyLetters = (text: string): string => text.replace(/[^A-Za-z]/g, '');

const masks = {
  numbers: (val: string): string => getOnlyNumber(val),

  letters: (val: string): string => getOnlyLetters(val),

  cep: (val: string): string => VMasker.toPattern(val, '99999-999'),

  currency: (val: string): string =>
    VMasker.toMoney(val, {
      // Decimal precision -> "90"
      precision: 2,
      // Decimal separator -> ",90"
      separator: ',',
      // Number delimiter -> "12.345.678"
      delimiter: '.',
      // Money unit -> "R$ 12.345.678,90"
      unit: '',
      // Money unit -> "12.345.678,90 R$"
      suffixUnit: '',
      // Force type only number instead decimal,
      // masking decimals with ",00"
      // Zero cents -> "R$ 1.234.567.890,00"
      zeroCents: false,
    }),

  cpf: (val: string): string => VMasker.toPattern(val, '999.999.999-99'),

  cnpj: (val: string): string => VMasker.toPattern(val, '99.999.999/9999-99'),

  passaport: (val: string): string => VMasker.toPattern(val, '999 999 999'),

  cpfOrCnpj: (val: string): string => {
    if (val.length > 14) return masks.cnpj(val);

    return masks.cpf(val);
  },

  phone: (val: string): string => VMasker.toPattern(val, '(99) 9999-9999'),

  cellphone: (val: string): string => VMasker.toPattern(val, '(99) 99999-9999'),

  cellphoneWithCountryCode: (val: string): string => VMasker.toPattern(val, '+99 (99) 99999-9999'),

  phoneOrCellphone: (val: string): string => {
    if (val.length > 14) return masks.cellphone(val);

    return masks.phone(val);
  },

  date: (val: string): string => VMasker.toPattern(val, '99/99/9999'),

  monthYear: (val: string): string => VMasker.toPattern(val, '99/9999'),

  cardnumber: (val: string): string => VMasker.toPattern(val, '9999.999.999999999-9'),

  uf: (val: string): string => VMasker.toPattern(val, 'AA').toUpperCase(),

  emailOrCpf: (val: string): string => {
    const isnum = /^\d+$/.test(val.replace(/-|\./g, ''));

    if (isnum) return masks.cpf(val);

    return val;
  },

  noSpecialChar: (val: string): string => {
    const text = val.toUpperCase();

    return text.normalize('NFD').replace(/\p{Diacritic}/gu, '');
  },
};

export default masks;
